<template>
  </template>
  
  <script>
  export default {
    name: 'GenericStub',
    inheritAttrs: false, // você controla com v-bind="$attrs"
  }
  </script>